
import { useCallback, useState } from "react";




export const useCheckData = (datos) => {


    const [selected, setSelected] = useState([]);
    

    const handleSelectAllClick = useCallback((event) => {
        if (event.target.checked) {
            const newSelected = datos.map((p) => p.id);
            setSelected(newSelected);
        } else {
            setSelected([]);
        }
    }, [datos]);



    const handleSelectAllClickUser = useCallback((event) => {
        if (event.target.checked) {
            const newSelected = datos.map((p) => p.id);
            setSelected(newSelected);
        } else {
            setSelected([]);
        }
    }, [datos]);
    


    const handleClick = useCallback((id) => {
        setSelected((items) => {
            const newSelected = items.includes(id) 
            ? items.filter((item) => item !== id) 
            : [...items, id];
            return newSelected;
        });
    }, []);



    const isSelected = useCallback( (id) => selected.includes(id), [selected]);
    

    return {
        selected,
        setSelected,
        handleSelectAllClick,
        handleSelectAllClickUser,
        handleClick,
        isSelected,
    }

}





